import { lazy } from 'react';

const View = lazy(() => import('./View'));

export { View };
